export const routePath = Object.freeze({
  Login: "/",
  Store: "/store",
  User: "/user",
  Notification: "/notification",
  Policy: "/policy",
  PolicyPublic: "/policy-public",
});
